import { Button, Typography } from '@mui/material';
import { Check } from '@ankr.com/ui';
import { useNavigate } from 'react-router';

import image from 'modules/common/assets/performance-upgrade.webp';
import { Dialog } from 'uiKit/Dialog';
import { checkoutRoutesConfig } from 'domains/checkout/routes';
import { useIsXSDown } from 'uiKit/Theme/useTheme';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { useUpgradeAccountDialogStyles } from './useUpgradeAccountDialogStyles';
import { upgradeAccountDialogTranslation } from './translation';

interface IUpgradeAccountDialogProps {
  isOpened: boolean;
  onClose: () => void;
  onGetPremiumButtonClick?: () => void;
}

const checkoutPath = checkoutRoutesConfig.checkout.generatePath();

export const UpgradeAccountDialog = ({
  isOpened,
  onClose,
  onGetPremiumButtonClick,
}: IUpgradeAccountDialogProps) => {
  const { classes } = useUpgradeAccountDialogStyles();

  const { keys, t } = useTranslation(upgradeAccountDialogTranslation);

  const isMobile = useIsXSDown();

  const navigate = useNavigate();

  const buttonSize = isMobile ? 'medium' : 'large';

  return (
    <Dialog
      classes={{ paper: classes.premiumDialogPaper }}
      closeButtonClassName={classes.closeButtonClassName}
      maxPxWidth={600}
      onClose={onClose}
      open={isOpened}
      title={
        <div className={classes.imageWrapper}>
          <img alt="Launch" className={classes.image} src={image} />
        </div>
      }
    >
      <div className={classes.upgradeAccountRoot}>
        <div className={classes.contentWrapper}>
          <Typography variant="h6" className={classes.title}>
            {t(keys.title)}
          </Typography>

          <Typography
            variant="body2"
            component="p"
            className={classes.description}
          >
            {t(keys.description)}
          </Typography>

          <Typography variant="body3" className={classes.item}>
            <Check size="s" />
            {t(keys.item1)}
          </Typography>
          <Typography variant="body3" className={classes.item}>
            <Check size="s" />
            {t(keys.item2)}
          </Typography>
          <Typography variant="body3" className={classes.item}>
            <Check size="s" />
            {t(keys.item3)}
          </Typography>
          <Typography variant="body3" className={classes.item}>
            <Check size="s" />
            {t(keys.item4)}
          </Typography>
          <Typography variant="body3" className={classes.item}>
            <Check size="s" />
            {t(keys.item5)}
          </Typography>
        </div>

        <Button
          className={classes.getPremiumButton}
          fullWidth
          onClick={onGetPremiumButtonClick ?? (() => navigate(checkoutPath))}
          size={buttonSize}
        >
          {t(keys.getPremium)}
        </Button>
        <Button
          fullWidth
          size={buttonSize}
          variant="outlined"
          onClick={onClose}
        >
          {t(keys.cancel)}
        </Button>
      </div>
    </Dialog>
  );
};
